import { PureComponent } from 'react';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ViewIcon } from 'foundations-assets';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import FullSenderName from '../senders/components/FullSenderName';
import Separator from '../atoms/Separator';
// @ts-expect-error Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import CommentActions from './CommentActions';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class CommentMessageHeader extends PureComponent {
  renderMetadata() {
    const {
      isLoading,
      sender,
      timestamp,
      senderName
    } = this.props;
    if (isLoading) {
      return /*#__PURE__*/_jsx(SkeletonText, {
        "data-test-id": "skeleton",
        inlineSize: "200px",
        use: "on-shade"
      });
    }
    return /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-inbox-message-history.commentMessageSubject',
        options: {
          name: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FullSenderName, {
              senderName: senderName,
              sender: sender
            })
          }),
          timestamp: /*#__PURE__*/_jsxs(Small, {
            "data-test-id": "comment-message-timestamp",
            children: [/*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(FormattedDateTime, {
              value: timestamp,
              format: "LT",
              type: "userTz"
            })]
          })
        }
      })
    });
  }
  render() {
    const {
      isHovered
    } = this.props;
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "start",
      justify: "between",
      direction: "row",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsxs(TFlex, {
        align: "start",
        justify: "between",
        direction: "column",
        wrap: "wrap",
        children: [this.props.renderHeaderMetadata ? this.props.renderHeaderMetadata() : this.renderMetadata(), /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: 'conversations-inbox-message-history.commentMessageTooltip',
            options: {
              icon: /*#__PURE__*/_jsx(View, {
                as: "span",
                marginInlineEnd: "100",
                children: /*#__PURE__*/_jsx(ViewIcon, {
                  size: "100"
                })
              })
            }
          })
        })]
      }), isHovered && this.props.handleClickToDelete ? /*#__PURE__*/_jsx(CommentActions, {
        handleClickToDelete: this.props.handleClickToDelete,
        onClickToDeleteComment: this.props.onClickToDeleteComment
      }) : null]
    });
  }
}
CommentMessageHeader.displayName = 'CommentMessageHeader';
CommentMessageHeader.defaultProps = {
  isHovered: false
};
export default CommentMessageHeader;